module.exports = __webpack_public_path__ + "static/prevent-employee-time-theft-d77b577613701f86ae0ca0bc9360a1e9.png";